import { Tags } from '../../../types';
export const wysiwygTagImports: Partial<
  Record<Tags, ReturnType<typeof defineAsyncComponent>>
> = {
  [Tags.TEXT]: defineAsyncComponent(
    () =>
      import(
        '~/components/components/cms/wysiwyg/components/tagHandlers/text.vue'
      ),
  ),
  [Tags.H1]: defineAsyncComponent(
    () =>
      import(
        '~/components/components/cms/wysiwyg/components/tagHandlers/vdv/headline.vue'
      ),
  ),
  [Tags.H2]: defineAsyncComponent(
    () =>
      import(
        '~/components/components/cms/wysiwyg/components/tagHandlers/vdv/headline.vue'
      ),
  ),
  [Tags.H3]: defineAsyncComponent(
    () =>
      import(
        '~/components/components/cms/wysiwyg/components/tagHandlers/vdv/headline.vue'
      ),
  ),
  [Tags.H4]: defineAsyncComponent(
    () =>
      import(
        '~/components/components/cms/wysiwyg/components/tagHandlers/vdv/headline.vue'
      ),
  ),
  [Tags.H5]: defineAsyncComponent(
    () =>
      import(
        '~/components/components/cms/wysiwyg/components/tagHandlers/vdv/headline.vue'
      ),
  ),
  [Tags.H6]: defineAsyncComponent(
    () =>
      import(
        '~/components/components/cms/wysiwyg/components/tagHandlers/vdv/headline.vue'
      ),
  ),
  [Tags.P]: defineAsyncComponent(
    () =>
      import(
        '~/components/components/cms/wysiwyg/components/tagHandlers/vdv/paragraph.vue'
      ),
  ),
  [Tags.IFRAME]: defineAsyncComponent(
    () =>
      import(
        '~/components/components/cms/wysiwyg/components/tagHandlers/iframe.vue'
      ),
  ),
  [Tags.SPAN]: defineAsyncComponent(
    () =>
      import(
        '~/components/components/cms/wysiwyg/components/tagHandlers/vdv/span.vue'
      ),
  ),
  [Tags.BUTTON]: defineAsyncComponent(
    () =>
      import(
        '~/components/components/cms/wysiwyg/components/tagHandlers/vdv/button.vue'
      ),
  ),
  [Tags.UL]: defineAsyncComponent(
    () =>
      import(
        '~/components/components/cms/wysiwyg/components/tagHandlers/vdv/list.vue'
      ),
  ),
  [Tags.OL]: defineAsyncComponent(
    () =>
      import(
        '~/components/components/cms/wysiwyg/components/tagHandlers/vdv/list.vue'
      ),
  ),
  [Tags.IMG]: defineAsyncComponent(
    () =>
      import(
        '~/components/components/cms/wysiwyg/components/tagHandlers/image.vue'
      ),
  ),
  [Tags.A]: defineAsyncComponent(
    () =>
      import(
        '~/components/components/cms/wysiwyg/components/tagHandlers/vdv/links.vue'
      ),
  ),
  [Tags.BR]: defineAsyncComponent(
    () =>
      import(
        '~/components/components/cms/wysiwyg/components/tagHandlers/br.vue'
      ),
  ),
  [Tags.TABLE]: defineAsyncComponent(
    () =>
      import(
        '~/components/components/cms/wysiwyg/components/tagHandlers/vdv/table.vue'
      ),
  ),
  [Tags.TBODY]: defineAsyncComponent(
    () =>
      import(
        '~/components/components/cms/wysiwyg/components/tagHandlers/vdv/tbody.vue'
      ),
  ),
  [Tags.TROW]: defineAsyncComponent(
    () =>
      import(
        '~/components/components/cms/wysiwyg/components/tagHandlers/vdv/trow.vue'
      ),
  ),
};
